import React from 'react';

const baseAssetsUrl = process.env.REACT_APP_BASE_ASSETS_URL;

const SORTABLE_COLUMNS = [
  { label: 'SKU', sortKey: 'SKU' },
  { label: 'Item', sortKey: 'Item' },
  { label: 'Collection', sortKey: 'Collection' },
  { label: 'Size', sortKey: 'Size' },
  { label: 'Stock ID', sortKey: 'Stock ID' },
];

const renderSortArrows = () => (
  <div className="up-down-arrow-btn">
    <img
      className="up-down-arrow-img up-down-arrow-img-forward active"
      src={`${baseAssetsUrl}images/icons/up-down-arrow.png`}
      alt=""
    />
    <img
      className="up-down-arrow-img up-down-arrow-img-reverse"
      src={`${baseAssetsUrl}images/icons/up-down-arrow-reverse.png`}
      alt=""
    />
  </div>
);

export function renderZoneIssueSortableHeader(label, sortKey, sortConfig, onSort) {
  const isActive = sortConfig?.key === sortKey;
  const ariaSort = isActive
    ? sortConfig.dir === 'asc'
      ? 'ascending'
      : 'descending'
    : 'none';
  const sortDirectionClass = isActive
    ? sortConfig.dir === 'asc'
      ? 'sorting_asc'
      : 'sorting_desc'
    : '';

  return (
    <th
      key={sortKey}
      className={`zone-create-edit__th-data zone-create-edit__th-sortable${
        sortKey === 'SKU' ? ' zone-create-edit__th-sku' : ''
      } sorting${sortDirectionClass ? ` ${sortDirectionClass}` : ''}`}
      onClick={() => onSort(sortKey)}
      aria-sort={ariaSort}
    >
      {label}
      {renderSortArrows()}
    </th>
  );
}

export function getZoneIssueSortableHeaders(t, sortConfig, onSort) {
  return SORTABLE_COLUMNS.map((column) =>
    renderZoneIssueSortableHeader(t(column.label), column.sortKey, sortConfig, onSort)
  );
}
